import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let WholePortionAnnexBAssociatedMoistureContentSection: React.FC<IWorksheetComponent> = () => {
  return (
    <>
      <WorksheetAssociatedTestSection
        name="Masses.AssociatedMoistureContent"
        heading={'Total Material Water Content'}
        testType="Moisture Content"
        associatedTestModel={{
          measured: true,
        }}
      />
      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.DryMass" />
      </ListFieldSection>
    </>
  );
};

WholePortionAnnexBAssociatedMoistureContentSection = withInjectedProps(
  WholePortionAnnexBAssociatedMoistureContentSection
);

export { WholePortionAnnexBAssociatedMoistureContentSection };
export default WholePortionAnnexBAssociatedMoistureContentSection;
